// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderDesk_header__SMWZ0","titleDiv":"HeaderDesk_titleDiv__h7MzD","mainTitle":"HeaderDesk_mainTitle__3GkyC","titleLetters":"HeaderDesk_titleLetters__2cG2b"};